import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toThunkRejectValue } from "../../../../Common/isRequestCanceled";
import {
  BASE_URL,
  EMPLOYEE_RATING_BY_ID_COUNT,
  EMPLOYEE_RATINGS_HOME,
  EMPLOYEE_RATINGS_REPORT,
  BASE_NODE_URL,
} from "../../../../Constants/Config";
import axios from "axios";
import { useAuthDetails } from "../../../../Common/cookiesHelper";

let employeeRatingDetailsController = null;
let employeeRatingDetailsDataCountController = null;

const initialState = {
  loading: false,
  EmployeeRatingsReportData: [],
  employeeRatingDetails: [],
  employeeRatingDelailsLoading: false,
  employeeRatingDetailsCount: 0,
  employeeAverageRating: 0,
  successMessage: "",
  error: "",
};

export const fetchEmployeeRatingsReportData = createAsyncThunk(
  "EmployeeRatingsReport/fetchEmployeeRatingsReportData.",
  async (data, { rejectWithValue }) => {
    const { userTypeData } = useAuthDetails();
    try {
      const { token, ...otherUserData } = userTypeData;
      const response = await axios.post(
        BASE_NODE_URL + EMPLOYEE_RATINGS_HOME,
        { ...data, ...otherUserData },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status === true) {
        return response.data.report_home_data;
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const fetchEmployeeRatingDetails = createAsyncThunk(
  "EmployeeRatingsReport/fetchEmployeeRatingDetails",
  async (data, { rejectWithValue }) => {
    const { userTypeData } = useAuthDetails();
    try {
      if (employeeRatingDetailsController) {
        employeeRatingDetailsController.abort();
      }
      employeeRatingDetailsController = new AbortController();
      const { token, ...otherUserData } = userTypeData;
      const response = await axios.post(
        BASE_NODE_URL + EMPLOYEE_RATINGS_REPORT,
        { ...data, ...otherUserData },
        {
          signal: employeeRatingDetailsController.signal,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status === true) {
        return response.data.report_data;
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const fetchEmployeeRatingDetailsDataCount = createAsyncThunk(
  "EmployeeRatingReport/fetchEmployeeRatingDetailsDataCount",
  async (data, { rejectWithValue }) => {
    const { userTypeData } = useAuthDetails();
    try {
      if (employeeRatingDetailsDataCountController) {
        employeeRatingDetailsDataCountController.abort();
      }
      employeeRatingDetailsDataCountController = new AbortController();
      const { token, ...otherUserData } = userTypeData;
      const response = await axios.post(
        BASE_NODE_URL + EMPLOYEE_RATING_BY_ID_COUNT,
        { ...data, ...otherUserData },
        {
          signal: employeeRatingDetailsDataCountController.signal,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status === true) {
        return response.data.report_total_count;
      } else {
        return 0;
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const EmployeeRatingsReportSlice = createSlice({
  name: "EmployeeRatingsReport",
  initialState,
  reducers: {
    updateStateOfEmployeeRatingsReport: (state, { payload }) => {
      state.EmployeeRatingsReportData = [];
      state.employeeRatingDetails = [];
      state.successMessage = "";
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchEmployeeRatingsReportData.fulfilled,
      (state, action) => {
        state.loading = false;
        state.EmployeeRatingsReportData = action.payload;
      }
    );
    builder.addCase(fetchEmployeeRatingsReportData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchEmployeeRatingsReportData.rejected, (state) => {
      state.loading = false;
    });
    // Details
    builder.addCase(fetchEmployeeRatingDetails.fulfilled, (state, action) => {
      state.employeeRatingDelailsLoading = false;
      state.employeeRatingDetails = action.payload;
    });
    builder.addCase(fetchEmployeeRatingDetails.pending, (state) => {
      state.employeeRatingDelailsLoading = true;
    });
    builder.addCase(fetchEmployeeRatingDetails.rejected, (state, action) => {
      if (action.payload?.message !== "canceled") {
        state.employeeRatingDelailsLoading = false;
      }
    });
    builder.addCase(
      fetchEmployeeRatingDetailsDataCount.fulfilled,
      (state, action) => {
        state.loading = false;
        state.employeeRatingDetailsCount = action.payload.total_count;
        state.employeeAverageRating = action.payload.avg_rating;
      }
    );
    builder.addCase(fetchEmployeeRatingDetailsDataCount.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      fetchEmployeeRatingDetailsDataCount.rejected,
      (state, action) => {
        if (action.payload?.message !== "canceled") {
          state.loading = false;
        }
      }
    );
  },
});

export const { updateStateOfEmployeeRatingsReport } =
  EmployeeRatingsReportSlice.actions;

export default EmployeeRatingsReportSlice.reducer;
